import React from 'react';

const ReferralTransitionFormModal = React.lazy(() => import('../components/FormModal'));
const referralTransitionModalRegistry = {
    core_referralTransitionId: ReferralTransitionFormModal
};
export default referralTransitionModalRegistry;
